<div class="additional-attachments-container" [formGroup]="formGroup">
    <div class="section-card">
        <!-- <p class="note">For Direct Crediting of commission into the following Bank Account
            (POSB/DBS accounts preferred)
        </p> -->
        <div class="container-fluid">
            <div class="row g-3">
                <div class="col-md-6">
                    <mat-label class="field-label">Written Authority to conduct inquiry into previous
                        employment
                        @if(readonly() === false){
                        <span class="download-btn" (click)="downloadForm(1)">Download Forms</span>
                        }
                    </mat-label>

                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="writtenAuthoritypreviousemploymentfileName"
                                accept=".pdf,.jpg,.jpeg,.png" [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event,'writtenAuthoritypreviousemploymentfileName','writtenAuthoritypreviousemployment')">
                            <input type="text" formControlName="writtenAuthoritypreviousemploymentfileName" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('writtenAuthoritypreviousemploymentfileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('writtenAuthoritypreviousemploymentfileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('writtenAuthoritypreviousemploymentfileName')?.value }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile('writtenAuthoritypreviousemploymentfileName','writtenAuthoritypreviousemployment')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment('writtenAuthoritypreviousemploymentfileName','writtenAuthoritypreviousemployment')">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["writtenAuthoritypreviousemploymentfileName"].invalid
                    && (this.formGroup.controls["writtenAuthoritypreviousemploymentfileName"].touched ||
                    this.formGroup.controls["writtenAuthoritypreviousemploymentfileName"].dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["writtenAuthoritypreviousemploymentfileName"].errors?.["required"])
                        {
                        <span>{{message}}</span>
                        }@else if(this.formGroup.controls["writtenAuthoritypreviousemploymentfileName"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["writtenAuthoritypreviousemploymentfileName"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">Letter of Undertaking for Register of Interests in Securities
                        @if(readonly() === false){
                        <span class="download-btn" (click)="downloadForm(4)">Download Forms</span>
                        }
                    </mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="LetterofUndertakingforRegisterofInterestsinSecuritiesfileName"
                                accept=".pdf,.jpg,.jpeg,.png" [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event,'LetterofUndertakingforRegisterofInterestsinSecuritiesfileName','LetterofUndertakingforRegisterofInterestsinSecurities')">
                            <input type="text"
                                formControlName="LetterofUndertakingforRegisterofInterestsinSecuritiesfileName" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('LetterofUndertakingforRegisterofInterestsinSecuritiesfileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('LetterofUndertakingforRegisterofInterestsinSecuritiesfileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{this.formGroup.get('LetterofUndertakingforRegisterofInterestsinSecuritiesfileName')?.value
                                    }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile('LetterofUndertakingforRegisterofInterestsinSecuritiesfileName','LetterofUndertakingforRegisterofInterestsinSecurities')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment('LetterofUndertakingforRegisterofInterestsinSecuritiesfileName','LetterofUndertakingforRegisterofInterestsinSecurities')">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["LetterofUndertakingforRegisterofInterestsinSecuritiesfileName"].invalid
                    && (this.formGroup.controls["LetterofUndertakingforRegisterofInterestsinSecuritiesfileName"].touched
                    ||
                    this.formGroup.controls["LetterofUndertakingforRegisterofInterestsinSecuritiesfileName"].dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["LetterofUndertakingforRegisterofInterestsinSecuritiesfileName"].errors?.["required"])
                        {
                        <span>{{message}}</span>
                        }@else if(this.formGroup.controls["LetterofUndertakingforRegisterofInterestsinSecuritiesfileName"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["LetterofUndertakingforRegisterofInterestsinSecuritiesfileName"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">Credit Bureau Report valid within the last 3 months</mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="creditBureauReportfileName" accept=".pdf,.jpg,.jpeg,.png"
                                [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event,'creditBureauReportfileName','creditBureauReport')">
                            <input type="text" formControlName="creditBureauReportfileName" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('creditBureauReportfileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('creditBureauReportfileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('creditBureauReportfileName')?.value }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile('creditBureauReportfileName','creditBureauReport')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment('creditBureauReportfileName','creditBureauReport')">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["creditBureauReportfileName"].invalid
                    && (this.formGroup.controls["creditBureauReportfileName"].touched ||
                    this.formGroup.controls["creditBureauReportfileName"].dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["creditBureauReportfileName"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }@else if(this.formGroup.controls["creditBureauReportfileName"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["creditBureauReportfileName"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">Past 15 Months CPF Transaction History (All transactions)</mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="CPFTransactionHistoryfileName" accept=".pdf,.jpg,.jpeg,.png"
                                [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event,'CPFTransactionHistoryfileName','CPFTransactionHistory')">
                            <input type="text" formControlName="CPFTransactionHistoryfileName" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('CPFTransactionHistoryfileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('CPFTransactionHistoryfileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('CPFTransactionHistoryfileName')?.value }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile('CPFTransactionHistoryfileName','CPFTransactionHistory')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment('CPFTransactionHistoryfileName','CPFTransactionHistory')">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["CPFTransactionHistoryfileName"].invalid
                    && (this.formGroup.controls["CPFTransactionHistoryfileName"].touched ||
                    this.formGroup.controls["CPFTransactionHistoryfileName"].dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["CPFTransactionHistoryfileName"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }@else if(this.formGroup.controls["CPFTransactionHistoryfileName"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["CPFTransactionHistoryfileName"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">Letter of Authorization to CPF Board
                        @if(readonly() === false){
                        <span class="download-btn" (click)="downloadForm(2)">Download Forms</span>
                        }
                    </mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="letterofAuthorizationtoCPFBoardfileName"
                                accept=".pdf,.jpg,.jpeg,.png" [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event,'letterofAuthorizationtoCPFBoardfileName','letterofAuthorizationtoCPFBoard')">
                            <input type="text" formControlName="letterofAuthorizationtoCPFBoardfileName" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('letterofAuthorizationtoCPFBoardfileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('letterofAuthorizationtoCPFBoardfileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('letterofAuthorizationtoCPFBoardfileName')?.value }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile('letterofAuthorizationtoCPFBoardfileName','letterofAuthorizationtoCPFBoard')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment('letterofAuthorizationtoCPFBoardfileName','letterofAuthorizationtoCPFBoard')">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["letterofAuthorizationtoCPFBoardfileName"].invalid
                    && (this.formGroup.controls["letterofAuthorizationtoCPFBoardfileName"].touched ||
                    this.formGroup.controls["letterofAuthorizationtoCPFBoardfileName"].dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["letterofAuthorizationtoCPFBoardfileName"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }
                        @else if(this.formGroup.controls["letterofAuthorizationtoCPFBoardfileName"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["letterofAuthorizationtoCPFBoardfileName"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">Acknowledgement of Transfer Rules Form
                        @if(readonly() === false){
                        <span class="download-btn" (click)="downloadForm(3)">Download Forms</span>
                        }
                    </mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="acknowledgementofTransferRulesFormfileName"
                                accept=".pdf,.jpg,.jpeg,.png" [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event,'acknowledgementofTransferRulesFormfileName','acknowledgementofTransferRulesForm')">
                            <input type="text" formControlName="acknowledgementofTransferRulesFormfileName" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('acknowledgementofTransferRulesFormfileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('acknowledgementofTransferRulesFormfileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('acknowledgementofTransferRulesFormfileName')?.value }}
                                </span>
                                 @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile('acknowledgementofTransferRulesFormfileName','acknowledgementofTransferRulesForm')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)=" previewAttachment('acknowledgementofTransferRulesFormfileName','acknowledgementofTransferRulesForm')">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["acknowledgementofTransferRulesFormfileName"].invalid
                    && (this.formGroup.controls["acknowledgementofTransferRulesFormfileName"].touched ||
                    this.formGroup.controls["acknowledgementofTransferRulesFormfileName"].dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["acknowledgementofTransferRulesFormfileName"].errors?.["required"])
                        {
                        <span>{{message}}</span>
                        }@else if(this.formGroup.controls["acknowledgementofTransferRulesFormfileName"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["acknowledgementofTransferRulesFormfileName"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                <div class="col-md-6">
                    <mat-label class="field-label">Passport-sized Photo (Color)</mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="passportsizedPhotofileName" accept=".pdf,.jpg,.jpeg,.png"
                                [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event,'passportsizedPhotofileName','passportsizedPhoto')">
                            <input type="text" formControlName="passportsizedPhotofileName" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('passportsizedPhotofileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('passportsizedPhotofileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('passportsizedPhotofileName')?.value }}
                                </span>
                                 @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile('passportsizedPhotofileName','passportsizedPhoto')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)=" previewAttachment('passportsizedPhotofileName','passportsizedPhoto')">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["passportsizedPhotofileName"].invalid
                    && (this.formGroup.controls["passportsizedPhotofileName"].touched ||
                    this.formGroup.controls["passportsizedPhotofileName"].dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["passportsizedPhotofileName"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }@else if(this.formGroup.controls["passportsizedPhotofileName"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["passportsizedPhotofileName"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>

            </div>
        </div>
    </div>

    <!-- Other Attachments -->
    <div class="section-card other-attachments-card">
        <div class="section-header">
            <mat-icon>attach_file</mat-icon>
            <span>Other Attachments</span>
        </div>
        <div class="container-fluid">
            <div class="row g-3">
                @for(key of otherAttachmentKeys; track key){
                <div class="col-md-6">
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" [id]="key + 'fileName'" accept=".pdf,.jpg,.jpeg,.png"
                                [disabled]="readonly()"
                                (change)="onAttachmentFileChange($event, key + 'fileName', key)">
                            <input type="text" [formControlName]="key + 'fileName'" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get(key + 'fileName')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get(key + 'fileName')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get(key + 'fileName')?.value }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="removeFile(key + 'fileName', key)">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment(key + 'fileName', key)">
                                 <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                        @if(readonly() === false){
                        @if(!$first){
                        @if(!this.formGroup.get(key + 'fileName')?.value){    
                        <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                            matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                            <mat-icon>close</mat-icon>
                        </button>
                        }
                        }
                        @if($last){
                        <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                            matTooltip="Add another attachment" (click)="addOtherAttachment()">
                            <mat-icon>add</mat-icon>
                        </button>
                        }
                        }
                    </div>
                    @if(this.formGroup.get(key + 'fileName')?.invalid
                    && (this.formGroup.get(key + 'fileName')?.touched ||
                    this.formGroup.get(key + 'fileName')?.dirty)
                    ) {
                    <mat-error>
                        @if(this.formGroup.get(key + 'fileName')?.errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.get(key + 'fileName')?.errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                }

            </div>
        </div>
    </div>
    @if(readonly() === false){
    <!-- Form Actions -->
    <div class="form-actions">

        <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

            <span>Save & Continue</span>
            <mat-icon>arrow_forward</mat-icon>

        </button>

    </div>
    }